import { RootState } from 'redux/store'

export const contactInfoFormSelector = (state: RootState) =>
  state.joinReducer.forms.contactInfo

export const locationAndFleetFormSelector = (state: RootState) =>
  state.joinReducer.forms.locationAndFleet

export const currentStepSelector = (state: RootState) =>
  state.joinReducer.currentStep

export const stationTypesSelector = (state: RootState) =>
  state.joinReducer.stationTypes
